import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "antd";
import { TriangleAlert } from "lucide-react";
import "./ExitCampaignGuard.scss";

interface SaveDraftModalProps {
  open: boolean;
  isSaving: boolean;
  onKeepEditing: () => void;
  onSaveAndExit: () => void;
}

const SaveDraftModal: FC<SaveDraftModalProps> = ({ open, isSaving, onKeepEditing, onSaveAndExit }) => {
  const { t } = useTranslation();

  return (
    <Modal
      className="confirmation-modal-content exit-campaign-modal"
      centered
      open={open}
      footer={null}
      onCancel={onKeepEditing}
    >
      <div className="confirmation-modal-wrapper">
        <div className="confirmation-modal-header">
          <TriangleAlert className="exit-campaign-modal__icon" size={20} aria-hidden />
          <label className="exit-campaign-modal__title">{t("campaignFlow.common.saveDraftTitle")}</label>
        </div>
        <div className="confirmation-modal-body exit-campaign-modal__description">
          {t("campaignFlow.common.saveDraftDescription")}
        </div>
        <div className="confirmation-modal-footer">
          <Button className="button button--outline" onClick={onKeepEditing} disabled={isSaving}>
            {t("campaignFlow.common.keepEditing")}
          </Button>
          <Button className="button button--primary" onClick={onSaveAndExit} loading={isSaving}>
            {t("campaignFlow.common.saveExit")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SaveDraftModal;
